import _classCallCheck from "/opt/bitnami/apache/htdocs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/bitnami/apache/htdocs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/bitnami/apache/htdocs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/bitnami/apache/htdocs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/bitnami/apache/htdocs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import Cookies from 'universal-cookie';
import { Provider } from './CookiesContext';
var CookiesProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(CookiesProvider, _React$Component);
  function CookiesProvider(props) {
    var _this;
    _classCallCheck(this, CookiesProvider);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CookiesProvider).call(this, props));
    if (props.cookies) {
      _this.cookies = props.cookies;
    } else {
      _this.cookies = new Cookies(undefined, props.defaultSetOptions);
    }
    return _this;
  }
  _createClass(CookiesProvider, [{
    key: "render",
    value: function render() {
      return React.createElement(Provider, {
        value: this.cookies
      }, this.props.children);
    }
  }]);
  return CookiesProvider;
}(React.Component);
export { CookiesProvider as default };